module.exports = __webpack_public_path__ + "static/img/Brands-Riëtte.d3f8f9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/nl/Brands-Riëtte.jpg
// module id = j5+v
// module chunks = 1